<div class="flex flex-col justify-center items-center h-screen gap-4">
  <h1 class="text-4xl font-bold">404 Error</h1>
  <h1 class="text-2xl">Page Not Found</h1>
  <button onclick="history.back()" class="btn-outline px-4 py-2 rounded">Go Back</button>
</div>
